import { Pipe, PipeTransform } from '@angular/core';
import { PaymentChargeAmounts } from '@shared/constants/constants';
import { CurrencyType } from '@shared/enums/CurrencyType';
import { PaymentProviderType } from '@shared/enums/PaymentProviderType';

@Pipe({
    name: 'paymentChargeAmount'
})
export class PaymentChargeAmountPipe implements PipeTransform {
    transform(paidEventPaymentProviderType: PaymentProviderType, paidEventCurrencyType: CurrencyType, type: string): number {
        let amount = 0;

        switch (type) {
            case 'min':
                amount = PaymentChargeAmounts?.find(x => x.paymentProviderType === paidEventPaymentProviderType && x.currencyType === paidEventCurrencyType)?.min;
                break;
            case 'max':
                amount = PaymentChargeAmounts?.find(x => x.paymentProviderType === paidEventPaymentProviderType && x.currencyType === paidEventCurrencyType)?.max;
                break;
        }

        return amount;
    }
}
